export default "__VITE_ASSET__78ab0780__"